// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file trade/v1/weight_display_unit.proto (package trade.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file trade/v1/weight_display_unit.proto.
 */
export const file_trade_v1_weight_display_unit: GenFile = /*@__PURE__*/
  fileDesc("CiJ0cmFkZS92MS93ZWlnaHRfZGlzcGxheV91bml0LnByb3RvEgh0cmFkZS52MSqAAQoRV2VpZ2h0RGlzcGxheVVuaXQSIwofV0VJR0hUX0RJU1BMQVlfVU5JVF9VTlNQRUNJRklFRBAAEiIKHldFSUdIVF9ESVNQTEFZX1VOSVRfU0NBTEVfVU5JVBABEiIKHldFSUdIVF9ESVNQTEFZX1VOSVRfUFJJQ0VfVU5JVBACQi9aLXBhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLXRyYWRlL2FwaS92MTt0cmFkZV92MWIIZWRpdGlvbnNw6Ac");

/**
 * WeightDisplayUnit represents how weights should be displayed for materials
 *
 * @generated from enum trade.v1.WeightDisplayUnit
 */
export enum WeightDisplayUnit {
  /**
   * @generated from enum value: WEIGHT_DISPLAY_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Display weights in actual scale units
   *
   * @generated from enum value: WEIGHT_DISPLAY_UNIT_SCALE_UNIT = 1;
   */
  SCALE_UNIT = 1,

  /**
   * Display weights in pricing/billing units
   *
   * @generated from enum value: WEIGHT_DISPLAY_UNIT_PRICE_UNIT = 2;
   */
  PRICE_UNIT = 2,
}

/**
 * Describes the enum trade.v1.WeightDisplayUnit.
 */
export const WeightDisplayUnitSchema: GenEnum<WeightDisplayUnit> = /*@__PURE__*/
  enumDesc(file_trade_v1_weight_display_unit, 0);

